// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { ProcessReadInputSchema } from "./ProcessReadInputSchema";
import {
  ProcessReadInputSchemaFromJSON,
  ProcessReadInputSchemaFromJSONTyped,
  ProcessReadInputSchemaToJSON,
  ProcessReadInputSchemaToJSONTyped,
} from "./ProcessReadInputSchema";
import type { TagsInner } from "./TagsInner";
import {
  TagsInnerFromJSON,
  TagsInnerFromJSONTyped,
  TagsInnerToJSON,
  TagsInnerToJSONTyped,
} from "./TagsInner";
import type { ProcessReadOutputSchema } from "./ProcessReadOutputSchema";
import {
  ProcessReadOutputSchemaFromJSON,
  ProcessReadOutputSchemaFromJSONTyped,
  ProcessReadOutputSchemaToJSON,
  ProcessReadOutputSchemaToJSONTyped,
} from "./ProcessReadOutputSchema";

/**
 *
 * @export
 * @interface ProcessRead
 */
export interface ProcessRead {
  /**
   *
   */
  id: string;
  /**
   *
   */
  createdAt: Date;
  /**
   *
   */
  updatedAt: Date;
  /**
   *
   */
  name: string;
  /**
   *
   */
  description?: string | null;
  /**
   *
   */
  tags?: Array<TagsInner>;
  /**
   *
   */
  system?: boolean;
  /**
   *
   */
  inputSchema: ProcessReadInputSchema;
  /**
   *
   */
  outputSchema: ProcessReadOutputSchema;
  /**
   *
   */
  inputOrder?: Array<string> | null;
  /**
   *
   */
  outputOrder?: Array<string> | null;
  /**
   *
   */
  readonly shortDescription: string | null;
}

/**
 * Check if a given object implements the ProcessRead interface.
 */
export function instanceOfProcessRead(value: object): value is ProcessRead {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (
    (!("createdAt" in (value as Record<string, any>)) &&
      !("created_at" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["createdAt"] === undefined &&
      (value as Record<string, any>)["created_at"] === undefined)
  )
    return false;
  if (
    (!("updatedAt" in (value as Record<string, any>)) &&
      !("updated_at" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["updatedAt"] === undefined &&
      (value as Record<string, any>)["updated_at"] === undefined)
  )
    return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  if (
    (!("inputSchema" in (value as Record<string, any>)) &&
      !("input_schema" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["inputSchema"] === undefined &&
      (value as Record<string, any>)["input_schema"] === undefined)
  )
    return false;
  if (
    (!("outputSchema" in (value as Record<string, any>)) &&
      !("output_schema" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["outputSchema"] === undefined &&
      (value as Record<string, any>)["output_schema"] === undefined)
  )
    return false;
  if (
    (!("shortDescription" in (value as Record<string, any>)) &&
      !("short_description" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["shortDescription"] === undefined &&
      (value as Record<string, any>)["short_description"] === undefined)
  )
    return false;
  return true;
}

export function ProcessReadFromJSON(json: any): ProcessRead {
  return ProcessReadFromJSONTyped(json, false);
}

export function ProcessReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProcessRead {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    createdAt: json["created_at"] == null ? json["created_at"] : parseDateTime(json["created_at"]),
    updatedAt: json["updated_at"] == null ? json["updated_at"] : parseDateTime(json["updated_at"]),
    name: json["name"],
    description:
      json["description"] === undefined
        ? undefined
        : json["description"] === null
        ? null
        : json["description"],
    tags: json["tags"] == null ? undefined : (json["tags"] as Array<any>).map(TagsInnerFromJSON),
    system: json["system"] == null ? undefined : json["system"],
    inputSchema: ProcessReadInputSchemaFromJSON(json["input_schema"]),
    outputSchema: ProcessReadOutputSchemaFromJSON(json["output_schema"]),
    inputOrder:
      json["input_order"] === undefined
        ? undefined
        : json["input_order"] === null
        ? null
        : json["input_order"],
    outputOrder:
      json["output_order"] === undefined
        ? undefined
        : json["output_order"] === null
        ? null
        : json["output_order"],
    shortDescription: json["short_description"],
  };
}

export function ProcessReadToJSON(json: any): ProcessRead {
  return ProcessReadToJSONTyped(json, false);
}

export function ProcessReadToJSONTyped(
  value?: Omit<ProcessRead, "shortDescription"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    created_at:
      value["createdAt"] == null ? value["createdAt"] : serializeDateTime(value["createdAt"]),
    updated_at:
      value["updatedAt"] == null ? value["updatedAt"] : serializeDateTime(value["updatedAt"]),
    name: value["name"],
    description: value["description"],
    tags: value["tags"] == null ? undefined : (value["tags"] as Array<any>).map(TagsInnerToJSON),
    system: value["system"],
    input_schema: ProcessReadInputSchemaToJSON(value["inputSchema"]),
    output_schema: ProcessReadOutputSchemaToJSON(value["outputSchema"]),
    input_order: value["inputOrder"],
    output_order: value["outputOrder"],
  };
}
